import React from 'react';
import { MapPinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="w-full bg-blue-900 text-white py-12" data-id="element-77">
      <div className="container mx-auto px-4" data-id="element-78">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-79">
          <div data-id="element-80">
            <h3 className="text-2xl font-bold mb-6" data-id="element-81">量盛科技</h3>
            <p className="text-blue-100 mb-6" data-id="element-82">
              专注于量化交易、高频交易和合约网格等金融科技领域，为客户提供专业、可靠的交易解决方案。
            </p>
          </div>
          <div data-id="element-83">
            <h3 className="text-xl font-bold mb-6" data-id="element-84">联系我们</h3>
            <ul className="space-y-4" data-id="element-85">
              <li className="flex items-start" data-id="element-86">
                <MapPinIcon size={20} className="mr-3 mt-1 flex-shrink-0" data-id="element-87" />
                <span data-id="element-88">福建省泉州市晋江市泉商投资大厦1801</span>
              </li>
              <li className="flex items-center" data-id="element-89">
                <MailIcon size={20} className="mr-3 flex-shrink-0" data-id="element-90" />
                <span data-id="element-91">shixingxing2022@gmail.com</span>
              </li>
            </ul>
          </div>
          <div data-id="element-92">
            <h3 className="text-xl font-bold mb-6" data-id="element-93">快速链接</h3>
            <ul className="space-y-3" data-id="element-94">
              <li data-id="element-95">
                <a href="#home" className="text-blue-100 hover:text-white transition-colors" data-id="element-96">
                  首页
                </a>
              </li>
              <li data-id="element-97">
                <a href="#business" className="text-blue-100 hover:text-white transition-colors" data-id="element-98">
                  业务范围
                </a>
              </li>
              <li data-id="element-99">
                <a href="#about" className="text-blue-100 hover:text-white transition-colors" data-id="element-100">
                  关于我们
                </a>
              </li>
              <li data-id="element-101">
                <a href="#contact" className="text-blue-100 hover:text-white transition-colors" data-id="element-102">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-blue-800 mt-12 pt-6 text-center text-blue-200" data-id="element-103">
          <p data-id="element-104">© {new Date().getFullYear()} 量盛科技 版权所有</p>
        </div>
      </div>
    </footer>;
}